const textEncoder =
    typeof TextEncoder !== "undefined" ? new TextEncoder() : null;

const bufferToHex = (buffer) =>
    Array.from(new Uint8Array(buffer))
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join("");

export const hashSha256 = async (value) => {
    const normalizedValue = String(value ?? "").trim();

    if (!normalizedValue) {
        return "";
    }

    if (
        typeof crypto === "undefined" ||
        !crypto.subtle ||
        typeof crypto.subtle.digest !== "function" ||
        !textEncoder
    ) {
        return normalizedValue;
    }

    const data = textEncoder.encode(normalizedValue);
    const digest = await crypto.subtle.digest("SHA-256", data);

    return bufferToHex(digest);
};
